import React, { Component } from 'react'
import './Loading.css'

class LoadingCard extends Component{

  render(){
    return (
        <div {...this.props} className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    );
  }
}

export default LoadingCard;
